import { getNumberFromString } from '../client/utility/formatNumbers';

//  COLLECTIONS
export const USERS = 'users';
export const PROPERTIES = 'properties';
export const SCENARIOS = 'scenarios';
export const REPORTS = 'reports';
export const IMAGES = 'images';
export const GRAPHS = 'graphs';
export const VISITORS = 'visitors';

export function cleanData(data) {
  const cleaned = {};
  Object.keys(data).forEach((key) => {
    const value = data[key];

    if (typeof value === 'string' && value !== '') {
      let formattedValue = value.trim();
      if (/^[0-9,.]+$/g.test(formattedValue)) {
        formattedValue = getNumberFromString(formattedValue);
      }
      cleaned[key] = formattedValue;
    } else if (value !== undefined) {
      cleaned[key] = value;
    }
  });
  return cleaned;
}
